"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { LEGAL_URLS } from "./legal_urls";
const LINK_PHRASES = [
  { text: "Notice at Collection", url: LEGAL_URLS.noticeAtCollection },
  { text: "Privacy Policy", url: LEGAL_URLS.privacyPolicy },
  { text: "SMS Terms", url: LEGAL_URLS.smsTermsOfService },
  { text: "Terms of Service", url: LEGAL_URLS.termsOfService },
  { text: "Terms", url: LEGAL_URLS.termsOfService }
];
const LEGAL_LINK_CLASS_NAME = "okta-widget-legal-link";
function createExternalAnchor({ text, url }) {
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.textContent = text;
  anchor.target = "_blank";
  anchor.rel = "noopener noreferrer";
  anchor.className = LEGAL_LINK_CLASS_NAME;
  return anchor;
}
function buildLinkedNodes(message, phrases) {
  const matches = phrases.map((phrase) => __spreadProps(__spreadValues({}, phrase), { index: message.indexOf(phrase.text) })).filter((phrase) => phrase.index !== -1).sort((a, b) => a.index - b.index);
  const nodes = [];
  let cursor = 0;
  matches.forEach((phrase) => {
    if (phrase.index < cursor) {
      return;
    }
    nodes.push(document.createTextNode(message.slice(cursor, phrase.index)));
    nodes.push(createExternalAnchor(phrase));
    cursor = phrase.index + phrase.text.length;
  });
  nodes.push(document.createTextNode(message.slice(cursor)));
  return nodes;
}
function getSmsEnrollmentSubtitle() {
  return "Enter your mobile number to receive a code to the phone number you provided via automated text or automated/prerecorded voice call to the mobile phone number you provide below. Message and data rates apply.";
}
function getSmsConsentMessage() {
  return 'By clicking "Receive a Code", you agree to receive a code sent by or on behalf of Triumph Bank, SSB d/b/a Triumph to the phone number you provided by automated text or automated/prerecorded voice call. Please see our Privacy Policy, SMS Terms, and Terms of Service.';
}
export function getOktaI18nOverrides() {
  const smsEnrollmentSubtitle = getSmsEnrollmentSubtitle();
  return {
    "oie.phone.enroll.call.subtitle": smsEnrollmentSubtitle,
    "oie.phone.enroll.sms.subtitle": smsEnrollmentSubtitle
  };
}
export function linkifyOktaSmsTerms(container) {
  container == null ? void 0 : container.querySelectorAll(".okta-form-subtitle").forEach((subtitle) => {
    var _a;
    const text = (_a = subtitle.textContent) != null ? _a : "";
    const hasLinkablePhrase = LINK_PHRASES.some(
      ({ text: phrase }) => text.includes(phrase)
    );
    if (!hasLinkablePhrase || subtitle.querySelector("a")) {
      return;
    }
    subtitle.replaceChildren(...buildLinkedNodes(text, LINK_PHRASES));
  });
}
const SMS_CONSENT_CLASS_NAME = "okta-widget-sms-consent";
export function insertOktaSmsConsent(container) {
  var _a;
  const isPhoneEnrollPage = !!(container == null ? void 0 : container.querySelector(
    ".phone-authenticator-enroll"
  ));
  const buttonBar = container == null ? void 0 : container.querySelector(".o-form-button-bar");
  if (!isPhoneEnrollPage || !buttonBar || (container == null ? void 0 : container.querySelector(`.${SMS_CONSENT_CLASS_NAME}`))) {
    return;
  }
  const paragraph = document.createElement("p");
  paragraph.className = `${SMS_CONSENT_CLASS_NAME} text_legal`;
  paragraph.append(...buildLinkedNodes(getSmsConsentMessage(), LINK_PHRASES));
  (_a = buttonBar.parentNode) == null ? void 0 : _a.insertBefore(paragraph, buttonBar);
}
function createPrivacyPolicyFooterLink() {
  const anchor = document.createElement("a");
  anchor.href = LEGAL_URLS.privacyPolicy;
  anchor.textContent = "Privacy Policy";
  anchor.target = "_blank";
  anchor.rel = "noopener noreferrer";
  anchor.className = "link";
  return anchor;
}
const MFA_SETUP_PRIVACY_POLICY_LINK_CLASS_NAME = "okta-widget-mfa-setup-privacy-policy-link";
export function insertOktaMfaSetupPrivacyPolicyLink(container) {
  const footer = container == null ? void 0 : container.querySelector(".enroll-choices .auth-footer");
  if (!footer || footer.querySelector(`.${MFA_SETUP_PRIVACY_POLICY_LINK_CLASS_NAME}`)) {
    return;
  }
  const anchor = createPrivacyPolicyFooterLink();
  anchor.classList.add(MFA_SETUP_PRIVACY_POLICY_LINK_CLASS_NAME);
  footer.prepend(anchor);
}
const PRIMARY_AUTH_CONTROLLER = "primary-auth";
const PRIMARY_AUTH_PRIVACY_POLICY_LINK_CLASS_NAME = "okta-widget-primary-auth-privacy-policy-link";
export function insertOktaPrimaryAuthPrivacyPolicyLink(container, controller) {
  if (controller !== PRIMARY_AUTH_CONTROLLER) {
    return;
  }
  const footer = container == null ? void 0 : container.querySelector(".auth-footer");
  if (!footer || footer.querySelector(`.${PRIMARY_AUTH_PRIVACY_POLICY_LINK_CLASS_NAME}`)) {
    return;
  }
  const anchor = createPrivacyPolicyFooterLink();
  anchor.classList.add(PRIMARY_AUTH_PRIVACY_POLICY_LINK_CLASS_NAME);
  footer.append(anchor);
}
function applyOktaWidgetCustomizations(container, controller) {
  linkifyOktaSmsTerms(container);
  insertOktaSmsConsent(container);
  insertOktaMfaSetupPrivacyPolicyLink(container);
  insertOktaPrimaryAuthPrivacyPolicyLink(container, controller);
}
export function registerOktaWidgetCustomizations(instance, containerId) {
  let subtitleObserver;
  instance.on("afterRender", (context) => {
    const container = document.getElementById(containerId);
    applyOktaWidgetCustomizations(container, context.controller);
    subtitleObserver == null ? void 0 : subtitleObserver.disconnect();
    if (container) {
      subtitleObserver = new MutationObserver(() => {
        applyOktaWidgetCustomizations(container, context.controller);
      });
      subtitleObserver.observe(container, {
        characterData: true,
        childList: true,
        subtree: true
      });
    }
  });
}
